module.exports = __webpack_public_path__ + "static/img/gkztc_logo.256b670c.png";